import { ColumnApi } from 'ag-grid-community';

export function applyColumnState(columnApi: ColumnApi, columnState: any) {
  try {
    columnApi.applyColumnState({
      state: columnState,
      applyOrder: true
    });
  } catch (e) {
    console.error('Unable to load column state');
  }
}
